import { FaRegTrashCan } from "react-icons/fa6";
import { BsPencilFill } from "react-icons/bs";
import { MdTimeline } from "react-icons/md";
import { Link } from 'react-router-dom';

function EditDeleteFooter({ to, toUpdate, openDelete }) {
    return (
        <div className="card-footer">
            <div className="card-footer-row">
                <div className="comment-button" style={{ color: '#9e1b1b' }} onClick={openDelete}>
                    <FaRegTrashCan /> &nbsp;Delete
                </div>
                <Link className="hide-link-styles" to={to}>
                    <div className="comment-button" style={{ color: '#2980b9' }}>
                        <BsPencilFill /> &nbsp;Edit
                    </div>
                </Link>
                {!!toUpdate && (
                    <Link className="hide-link-styles" to={toUpdate}>
                        <div className="comment-button" style={{ color: '#27ae60' }}>
                            <MdTimeline size={24}/> &nbsp;Update
                        </div>
                    </Link>
                )}
            </div>
        </div>
    );
}

export default EditDeleteFooter;